import { createFileRoute } from '@tanstack/react-router';

import { getGetSentenceQueryOptions, getListDirectivesQueryOptions } from '@praetoid/client';

import SentencePage from '~/app/sentences/SentencePage';

export const Route = createFileRoute('/_app/home/sentences/$sentenceId')({
	beforeLoad: () => {
		return {
			getTitle: 'Sentence Details'
		};
	},
	loader: async ({ context: { queryClient }, params: { sentenceId } }) => {
		await Promise.all([
			queryClient.ensureQueryData(getGetSentenceQueryOptions(sentenceId)),
			queryClient.ensureQueryData(getListDirectivesQueryOptions())
		]);
	},
	component: SentencePage
});
